/**
 * @ngdoc directive
 * @name lspEmailsValidator.directive:lspEmailsDirective
 * @description
 * # lspEmails
 */

function lspEmails() {
  const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return {
    require: ['ngModel'],
    restrict: 'A',
    link: (scope, elm, attrs, ctrl) => {
      // only apply the validator if ngModel is present
      if (ctrl[0]) {
        ctrl[0].$validators.lspEmails = (modelValue) => {
          if (ctrl[0].$isEmpty(modelValue)) {
            return true;
          }
          const splitEmails = modelValue.split(',');
          for (let email of splitEmails) {
              if(!EMAIL_REGEXP.test(email.trim())) {
                return false;
              }
          }
          return true;
        }
      }
    },
  };
}

export default lspEmails;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-validators/lsp-emails-validator/lsp-emails-directive.js